import { useEffect } from 'react'

import request from 'api'
import { useDateTime } from 'hooks'
import { putData, useAppDispatch, useAppSelector } from 'store'

export type RegisteredDeviceResponse = {
  modelCode: string
  modelName: string
  productType: string
  serialNumber: string
  registrationTimestamp: string
  imageUrl?: string
}

export type RegisteredDevice = {
  modelCode: string
  modelName: string
  productType: string
  serialNumber: string
  registrationTimestamp: string
  imageUrl: string
  displayDate: string
}

const dummy: RegisteredDevice[] = []
export function useRegisteredDevices(forceFetch = false) {
  const mobileDeviceTypes = ['earbuds', 'phone', 'tablet', 'watch', 'ring']

  const registeredDevices = useAppSelector((state) => state.data.registeredDevices as RegisteredDevice[])
  const dispatch = useAppDispatch()

  const dateTime = useDateTime()

  const fetchData = async () => {
    const fetchedData = await request
      .get<{ products: RegisteredDeviceResponse[] }>('/v2/products')
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('FailedToFetch')
        }

        if (!response.data.products) {
          throw new Error('Failed getRegisteredDevices')
        }
        return response.data.products
      })
      .then((registeredDevices) => {
        const organized = registeredDevices.map((registeredDevice) => {
          let modelName = registeredDevice.modelName
          if (mobileDeviceTypes.includes(registeredDevice.productType.toLowerCase())) {
            modelName =
              registeredDevice.modelCode.length >= 7 ? registeredDevice.modelCode.slice(0, 7) : registeredDevice.modelCode
          }
          return {
            modelCode: registeredDevice.modelCode,
            modelName: modelName,
            productType: registeredDevice.productType,
            serialNumber: registeredDevice.serialNumber,
            registrationTimestamp: registeredDevice.registrationTimestamp,
            imageUrl: registeredDevice.imageUrl || null,
            displayDate: registeredDevice.registrationTimestamp && dateTime(registeredDevice.registrationTimestamp)
          } as RegisteredDevice
        })
        return organized
      })
      .catch(() => {
        return dummy
      })

    dispatch(putData({ registeredDevices: fetchedData }))
    return fetchedData
  }

  const deleteRegisteredDevice = async (serialNumber: string) => {
    const isDeleted = await request
      .delete(`/v2/products/${serialNumber}`)
      .then(() => {
        return true
      })
      .catch(() => {
        return false
      })

    if (isDeleted) {
      if (registeredDevices === undefined) {
        // do nothing
      } else {
        dispatch(
          putData({
            registeredDevices: registeredDevices.filter((registeredDevice) => registeredDevice.serialNumber !== serialNumber)
          })
        )
      }
      return true
    } else {
      return false
    }
  }

  useEffect(() => {
    if (forceFetch || registeredDevices === undefined) {
      fetchData()
    }
  }, [])

  return {
    registeredDevices: registeredDevices === undefined ? dummy : registeredDevices,
    isInitializing: registeredDevices === undefined,
    fetchRegisteredDevices: fetchData,
    deleteRegisteredDevice
  }
}
